
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../api/config"; // Ensure this path is correct
import JSLayout from "./js_layout";

const css = `
  .jd-layout { display: grid; grid-template-columns: 1fr 340px; gap: 1.5rem; align-items: start; }
  .jd-main-card { background: #fff; border: 1px solid rgba(var(--color-text-rgb),0.07); border-radius: 4px; overflow: hidden; }
  .jd-hero { background: var(--color-text); padding: 2rem 2rem 1.5rem; position: relative; overflow: hidden; }
  .jd-hero::before { content:''; position:absolute; top:-60px; right:-60px; width:220px; height:220px; border-radius:50%; border:1px solid rgba(var(--color-primary-rgb),0.1); }
  .jd-hero-top { display: flex; align-items: flex-start; gap: 1rem; margin-bottom: 1.25rem; }
  .jd-hero-logo { width: 56px; height: 56px; border-radius: 6px; background: rgba(255,255,255,0.07); border: 1px solid rgba(var(--color-primary-rgb),0.2); display: flex; align-items: center; justify-content: center; font-size: 1.6rem; flex-shrink: 0; }
  .jd-hero-info { flex: 1; }
  .jd-hero-title { font-family: 'DM Sans', sans-serif; font-size: 1.8rem; font-weight: 600; color: var(--color-bg-subtle); line-height: 1.15; margin-bottom: 4px; }
  .jd-hero-company { font-size: 0.9rem; color: rgba(245,240,232,0.6); font-weight: 300; margin-bottom: 10px; }
  .jd-hero-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .jd-hero-tag { font-size: 0.68rem; padding: 3px 10px; border-radius: 2px; background: rgba(255,255,255,0.07); color: rgba(245,240,232,0.7); }
  .jd-hero-tag.gold { background: rgba(var(--color-primary-rgb),0.15); color: var(--color-primary); }
  .jd-back-btn { background: none; border: none; cursor: pointer; color: rgba(245,240,232,0.4); font-size: 0.78rem; display: flex; align-items: center; gap: 0.4rem; padding: 0; margin-bottom: 1rem; transition: color 0.2s; }
  .jd-back-btn:hover { color: var(--color-primary); }

  .jd-body { padding: 2rem; }
  .jd-section { margin-bottom: 2rem; }
  .jd-section:last-child { margin-bottom: 0; }
  .jd-section-label { font-size: 0.68rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #aaa; margin-bottom: 0.75rem; display: flex; align-items: center; gap: 0.5rem; }
  .jd-section-label::after { content:''; flex:1; height:1px; background:rgba(var(--color-text-rgb),0.06); }
  .jd-desc { font-size: 0.88rem; font-weight: 300; color: #444; line-height: 1.85; }
  .jd-list { list-style: none; display: flex; flex-direction: column; gap: 0.5rem; }
  .jd-list li { font-size: 0.85rem; font-weight: 300; color: #444; display: flex; align-items: flex-start; gap: 0.6rem; line-height: 1.5; }
  .jd-list li::before { content:'—'; color:var(--color-primary); flex-shrink:0; font-weight:500; }
  .jd-skill-grid { display: flex; flex-wrap: wrap; gap: 0.5rem; }
  .jd-skill { font-size: 0.75rem; padding: 5px 12px; background: var(--color-bg-subtle); border: 1px solid rgba(var(--color-text-rgb),0.08); border-radius: 2px; color: #555; }
  .jd-meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
  .jd-meta-item { background: #f9f7f3; border-radius: 3px; padding: 0.85rem 1rem; }
  .jd-meta-label { font-size: 0.62rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; color: #aaa; margin-bottom: 4px; }
  .jd-meta-value { font-size: 0.88rem; font-weight: 500; color: var(--color-text); }

  /* sidebar */
  .jd-sidebar-card { background: #fff; border: 1px solid rgba(var(--color-text-rgb),0.07); border-radius: 4px; padding: 1.5rem; margin-bottom: 1rem; }
  .jd-sidebar-card:last-child { margin-bottom: 0; }
  .jd-apply-btn { width: 100%; padding: 1rem; background: var(--color-text); color: var(--color-bg-subtle); border: none; border-radius: 2px; font-family: 'DM Sans', sans-serif; font-size: 0.78rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; cursor: pointer; transition: background 0.2s; margin-bottom: 0.65rem; }
  .jd-apply-btn:hover { background: var(--color-primary); color: var(--color-text); }
  .jd-save-btn-lg { width: 100%; padding: 0.85rem; background: transparent; color: #888; border: 1px solid rgba(var(--color-text-rgb),0.12); border-radius: 2px; font-family: 'DM Sans', sans-serif; font-size: 0.78rem; font-weight: 400; letter-spacing: 0.08em; text-transform: uppercase; cursor: pointer; transition: all 0.2s; }
  .jd-save-btn-lg:hover, .jd-save-btn-lg.saved { border-color: var(--color-primary); color: var(--color-primary); }
  .jd-sidebar-title { font-family: 'DM Sans', sans-serif; font-size: 1rem; font-weight: 600; color: var(--color-text); margin-bottom: 0.85rem; }
  .jd-sidebar-title em { font-style: normal; }
  .jd-detail-row { display: flex; justify-content: space-between; align-items: center; padding: 0.55rem 0; border-bottom: 1px solid rgba(var(--color-text-rgb),0.05); font-size: 0.82rem; }
  .jd-detail-row:last-child { border-bottom: none; }
  .jd-detail-key { color: #aaa; font-weight: 300; }
  .jd-detail-val { color: var(--color-text); font-weight: 500; text-align: right; }
  .jd-match-ring { width: 72px; height: 72px; margin: 0 auto 0.75rem; position: relative; }
  .jd-match-ring svg { transform: rotate(-90deg); }
  .jd-match-pct { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-family: 'DM Sans', sans-serif; font-size: 1.3rem; font-weight: 600; color: var(--color-primary); }
  .jd-match-label { text-align: center; font-size: 0.72rem; color: #aaa; }
  .jd-match-sub { text-align: center; font-size: 0.75rem; color: #555; margin-top: 0.5rem; line-height: 1.5; }

  /* apply modal */
  .jd-modal-bg { position: fixed; inset: 0; z-index: 100; background: rgba(0,0,0,0.55); display: flex; align-items: flex-end; justify-content: center; }
  @media (min-width: 600px) { .jd-modal-bg { align-items: center; } }
  .jd-modal { background: #fff; border-radius: 6px 6px 0 0; width: 100%; max-width: 560px; padding: 2rem; max-height: 92vh; overflow-y: auto; }
  @media (min-width: 600px) { .jd-modal { border-radius: 4px; } }
  .jd-modal-hdr { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.5rem; }
  .jd-modal-title { font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 600; color: var(--color-text); line-height: 1.2; }
  .jd-modal-title em { font-style: normal; color: var(--color-primary); }
  .jd-modal-sub { font-size: 0.8rem; color: #888; margin-top: 3px; }
  .jd-modal-close { background: none; border: none; cursor: pointer; font-size: 1.2rem; color: #aaa; padding: 0; line-height: 1; }
  .jd-modal-actions { display: flex; gap: 0.75rem; margin-top: 1.5rem; }
  .jd-modal-actions button { flex: 1; }
  .jd-success { text-align: center; padding: 1rem 0; }
  .jd-success-icon { font-size: 2.5rem; margin-bottom: 1rem; }
  .jd-success-title { font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 600; color: var(--color-text); margin-bottom: 0.5rem; }
  .jd-success-sub { font-size: 0.85rem; color: #888; font-weight: 300; line-height: 1.6; }

  @media (max-width: 900px) { .jd-layout { grid-template-columns: 1fr; } }
  @media (max-width: 600px) {
    .jd-hero { padding: 1.5rem; }
    .jd-hero-title { font-size: 1.5rem; }
    .jd-body { padding: 1.25rem; }
    .jd-meta-grid { grid-template-columns: 1fr; }
  }
`;

// ... keep your 'const css' string here ...

export default function JobDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // State for API data
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const [saved, setSaved] = useState(false);
  const [modal, setModal] = useState(false);
  const [cover, setCover] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // Inject CSS
  useEffect(() => {
    if (typeof document !== "undefined" && !document.getElementById("bl-jd-css")) {
      const s = document.createElement("style");
      s.id = "bl-jd-css";
      s.textContent = css;
      document.head.appendChild(s);
    }
  }, []);

  // Fetch Job Details
  useEffect(() => {
    const fetchJobDetail = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${API_ENDPOINTS.EMPJOBS}/${id}`, {
          headers: { "Authorization": `Bearer ${token}` }
        });
        if (response.ok) {
          const result = await response.json();
          setJob(result);
          setSaved(result.isSaved);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Job fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchJobDetail();
  }, [id]);

  // const handleApply = async () => {
  //   if (!cover.trim()) return;
    
  //   const token = localStorage.getItem("token");
  //   try {
  //     const response = await fetch(`${API_ENDPOINTS.EMPJOBS}/${id}/apply`, {
  //       method: "POST",
  //       headers: { 
  //         "Authorization": `Bearer ${token}`,
  //         "Content-Type": "application/json"
  //       },
  //       body: JSON.stringify({ coverNote: cover })
  //     });

  //     if (response.ok) {
  //       setSubmitted(true);
  //     } else {
  //       const err = await response.json();
  //       alert(err.message || "Failed to submit application.");
  //     }
  //   } catch (err) {
  //     console.error("Application error:", err);
  //   }
  // };

  const [isSubmitting, setIsSubmitting] = useState(false);

const handleApply = async () => {
  if (!cover.trim()) return;
  
  setIsSubmitting(true); // Start loading
  const token = localStorage.getItem("token");
  
  try {
    const response = await fetch(`${API_ENDPOINTS.EMPJOBS}/${id}/apply`, {
      method: "POST",
      headers: { 
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ coverNote: cover.trim() })
    });

    if (response.ok) {
      setSubmitted(true);
      setCover(""); // Clear input on success
    } else if (response.status === 401) {
      alert("Your session has expired. Please log in again.");
      navigate("/login");
    } else {
      const err = await response.json();
      alert(err.message || "Failed to submit application. Please try again.");
    }
  } catch (err) {
    console.error("Application error:", err);
    alert("Network error. Please check your internet connection.");
  } finally {
    setIsSubmitting(false); // End loading
  }
};

  const toggleSave = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${API_ENDPOINTS.EMPJOBS}/${id}/save`, {
      method: "POST",
      headers: { "Authorization": `Bearer ${token}` }
    });

    if (response.ok) {
      const result = await response.json();
      setSaved(result.saved); // Updates the UI state (heart icon)
    }
  } catch (err) {
    console.error("Save error:", err);
  }
};

  if (loading) return <JSLayout title="Loading..."><div>Refining details...</div></JSLayout>;
  
  if (error || !job) return (
    <JSLayout title="Not Found">
      <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
        <p>We couldn't find that job listing.</p>
        <button className="bl-btn-gold" onClick={() => navigate("/jobs")}>Back to Jobs</button>
      </div>
    </JSLayout>
  );

  const circumference = 2 * Math.PI * 28;
  const offset = circumference - (job.match / 100) * circumference;

  const COMPLETION_THRESHOLD = 80;
  const isProfileComplete = job?.currentUserProfileScore >= COMPLETION_THRESHOLD;

  return (
    <JSLayout title={job.title} titleEm={job.company}>
      {/* Back navigation action utility */}
        <button 
          onClick={() => navigate(-1)} 
          style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', marginBottom: '1.5rem', padding: 0, fontSize: '0.9rem' }}
        >
          ← Back to discovery board
        </button>

      <div className="jd-layout">
        {/* left — main content */}
        <div>
          <div className="jd-main-card">
            <div className="jd-hero">
              <div className="jd-hero-top">
                <div className="jd-hero-logo">{job.icon || "💼"}</div>
                <div className="jd-hero-info">
                  <div className="jd-hero-title">{job.title}</div>
                  <div className="jd-hero-company">{job.company}</div>
                  <div className="jd-hero-tags">
                    <span className="jd-hero-tag">📍 {job.location}</span>
                    <span className="jd-hero-tag">{job.type}</span>
                    <span className="jd-hero-tag">{job.experience} exp</span>
                    <span className="jd-hero-tag gold">{job.salary}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="jd-body">
              <div className="jd-section">
                <div className="jd-section-label">About the role</div>
                <p className="jd-desc">{job.desc}</p>
              </div>

              {job.responsibilities?.length > 0 && (
                <div className="jd-section">
                  <div className="jd-section-label">Responsibilities</div>
                  <ul className="jd-list">
                    {job.responsibilities.map((r, i) => <li key={i}>{r}</li>)}
                  </ul>
                </div>
              )}

              {job.requirements?.length > 0 && (
                <div className="jd-section">
                  <div className="jd-section-label">Requirements</div>
                  <ul className="jd-list">
                    {job.requirements.map((r, i) => <li key={i}>{r}</li>)}
                  </ul>
                </div>
              )}

              <div className="jd-section">
                <div className="jd-section-label">Skills & expertise</div>
                <div className="jd-skill-grid">
                  {job.skills?.map(s => <span key={s} className="jd-skill">{s}</span>)}
                </div>
              </div>

              <div className="jd-section">
                <div className="jd-section-label">Job details</div>
                <div className="jd-meta-grid">
                  {[
                    ["Job Type", job.type],
                    ["Location", job.location],
                    ["Salary", job.salary],
                    ["Experience", job.experience],
                    ["Posted", job.posted],
                    ["Apply by", job.deadline]
                  ].map(([k, v]) => (
                    <div key={k} className="jd-meta-item">
                      <div className="jd-meta-label">{k}</div>
                      <div className="jd-meta-value">{v}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* right — sidebar */}
        <div>
          {/* <div className="jd-sidebar-card">
            <div className="jd-match-ring">
              <svg width="72" height="72" viewBox="0 0 72 72">
                <circle cx="36" cy="36" r="28" fill="none" stroke="rgba(var(--color-text-rgb),0.07)" strokeWidth="5" />
                <circle cx="36" cy="36" r="28" fill="none" stroke="var(--color-primary)" strokeWidth="5" strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" />
              </svg>
              <div className="jd-match-pct">{job.match}%</div>
            </div>
            <div className="jd-match-label">Profile match</div>
            <div className="jd-match-sub">Your profile is a strong match for this role. Complete your portfolio to improve it further.</div>
            </div> */}
          {job.hasApplied ?
          (
            <div className="jd-sidebar-card">
              <div className="jd-applied-banner">
                <div className="jd-applied-status">
                  <span className="jd-success-icon">✅</span> Applied
                </div>
                <div className="jd-applied-date">
                  You applied for this role on <strong>{job.appliedDate}</strong>
                </div>
              </div>
            </div>
              
          ) : (
            <div className="jd-sidebar-card">
              <button className="jd-apply-btn" onClick={() => setModal(true)}>
                  Apply for this role
                </button>
              
              <button 
                className={`jd-save-btn-lg${saved ? " saved" : ""}`} 
                onClick={toggleSave}>
                {saved ? "♥ Saved" : "♡ Save job"}
              </button>
            </div>
          )
          }

          <div className="jd-sidebar-card">
            <div className="jd-sidebar-title">Quick <em>details</em></div>
            {[
              ["Salary", job.salary],
              ["Type", job.type],
              ["Location", job.location],
              ["Experience", job.experience],
              ["Deadline", job.deadline]
            ].map(([k, v]) => (
              <div key={k} className="jd-detail-row">
                <span className="jd-detail-key">{k}</span>
                <span className="jd-detail-val">{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* apply modal */}
      {modal && (
        <div className="jd-modal-bg" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="jd-modal">
            {submitted ? (
              <div className="jd-success">
                <div className="jd-success-icon">✅</div>
                <div className="jd-success-title">Application sent!</div>
                <div className="jd-success-sub">Your application for <strong>{job.title}</strong> at {job.company} has been submitted.</div>
                <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center", marginTop: "1.5rem" }}>
                  <button className="bl-btn-primary" onClick={() => navigate("/applications")}>View Applications</button>
                  <button className="bl-btn-ghost" onClick={() => { setModal(false); setSubmitted(false); setCover(""); }}>Close</button>
                </div>
              </div>
            ) : !isProfileComplete? (
              
              /* 2. INCOMPLETE PROFILE VIEW (The notice you wanted) */
              <div className="jd-incomplete-view">
                <div className="jd-modal-hdr">
                  <div>
                    <div className="jd-modal-title">Profile <em>Incomplete</em></div>
                    <div className="jd-modal-sub">Current Progress: {job.currentUserProfileScore}%</div>
                  </div>
                  <button className="jd-modal-close" onClick={() => setModal(false)}>✕</button>
                </div>
                
                <div className="jd-notice-body" style={{ padding: "1.5rem 0", textAlign: "center" }}>
                  <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📝</div>
                  <p>To apply for jobs on <strong>RemboList</strong>, your profile must be at least <strong>{COMPLETION_THRESHOLD}%</strong> complete.</p>
                  <p style={{ color: "#666", fontSize: "0.9rem", marginTop: "0.5rem" }}>
                    Employers need to see your CV and certifications before they can review your application.
                  </p>
                </div>

                <div className="jd-modal-actions" style={{ flexDirection: "column", gap: "0.5rem" }}>
                  <button className="bl-btn-gold" style={{ width: "100%" }} onClick={() => navigate("/profile")}>
                    Complete My Profile
                  </button>
                  <button className="bl-btn-ghost" style={{ width: "100%" }} onClick={() => setModal(false)}>
                    Maybe Later
                  </button>
                </div>
              </div>

            ) :(
              <>
                <div className="jd-modal-hdr">
                  <div>
                    <div className="jd-modal-title">Apply for <em>{job.title}</em></div>
                    <div className="jd-modal-sub">{job.company} · {job.location}</div>
                  </div>
                  <button className="jd-modal-close" onClick={() => setModal(false)}>✕</button>
                </div>
                <div className="bl-field">
                  <label className="bl-label">Cover note</label>
                  <textarea className="bl-textarea" rows={5} placeholder={`Tell ${job.company} why you're a great fit...`} value={cover} onChange={e => setCover(e.target.value)} />
                </div>
                <div className="jd-modal-actions">
                  <button className="bl-btn-ghost" onClick={() => setModal(false)}>Cancel</button>
                  <button className="bl-btn-gold" onClick={handleApply} disabled={!cover.trim() || isSubmitting}>
                    {isSubmitting ? "Submitting..." : "Submit Application"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </JSLayout>
  );
}